import React from "react"
import { Input } from "src/components/ui/input"
import { Label } from "src/components/ui/label"

// A single labeled money line for the cost-sheet composer: a left-aligned label
// and a right-aligned numeric input with a ₹ prefix. Controlled — `value` is the
// raw string the user typed; `onChange` receives the raw string.
export function CostComponentRow({ label, value, onChange, placeholder = "0", disabled = false }) {
  return (
    <div className="flex items-center justify-between gap-3">
      <Label className="text-[13px] font-normal text-slate-600">{label}</Label>
      <div className="relative w-40">
        <span className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-xs text-slate-400">₹</span>
        <Input
          type="number"
          inputMode="decimal"
          min="0"
          className="h-8 pl-6 text-right text-[13px] tabular-nums"
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  )
}
